module.exports = __webpack_public_path__ + "static/media/chubby.b2baddef.png";